export const sliderItems=[
    
                {
                    id:1,
                img:"https://wallpapercave.com/wp/wp4399018.jpg",
           
                    title:"SUMMER SALE",
                    desc:"DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
                    
               
               
                 bg:"f5fafd",
                },
                {
                    id:2,
                img:"https://wallpapercave.com/wp/wp4562241.jpg",
                
                    title:"WINTER SALE",
                    desc:"STYLE COOL, BE WARM",
                   bg:"fcfled",
                },
               
        {
            id:3,
                
                
                img:"https://cdn.suwalls.com/wallpapers/girls/miranda-kerr-13294-1920x1200.jpg",
                
                    title:"POPULAR SALE",
                    desc:"GO WITH THE TREND.",
                
                    bg:"fbf0f4",
                }
];
export const categories=[
    
    {
        id:1,
    img:"https://en.tarajarmon.ch/img/look/931/look_1393.jpg",

        title:"SHIRT STYLE!",
        
        
   
   
     
    },
    {
        id:2,
    img:"https://images.hdqwalls.com/download/zara-larsson-elle-2019-as-1440x2560.jpg",
    
        title:"LOUNGEWEAR LOVE!",
        
    },
   
{
id:3,
    
    
    img:"https://static.zara.net/photos///2023/V/0/1/p/1014/317/800/2/w/296/1014317800_1_1_1.jpg?ts=1674052776722",
    
        title:"LIGHT JACKETS",
        
    }
];

export const popularProducts = [
    
    
        {
            id:1,
        img:"https://www.pngall.com/wp-content/uploads/2016/05/Baseball-Cap-PNG-Picture.png",
    
            
            
            
       
       
         
        },
        {
            id:2,
        img:"https://www.pngall.com/wp-content/uploads/4/Leather-Jacket-PNG-Pic.png",
        
           
            
        },
       
    {
    id:3,
        
        
        img:"https://www.pngall.com/wp-content/uploads/2/Bag-PNG-Image-File.png",
        
           
            
        },
        {
            id:4,
        img:"https://img.lovepik.com/free-png/20211106/lovepik-glove-png-image_400417304_wh1200.png",
        
           
            
        },
        {
            id:5,
        img:"https://www.pngmart.com/files/16/Ripped-Jeans-Transparent-Background.png",
        
           
            
        },
        {
            id:6,
        img:"https://www.pngall.com/wp-content/uploads/2016/05/Perfume-Free-Download-PNG.png",
        
           
            
        },
        {
            id:7,
        img:"https://en.tarajarmon.ch/img/home/687/4_2_498c6f1e1ba939d77681a7d7c632d6a8.1676909379.jpeg",
        
           
            
        },
        {
            id:8,
        img:"https://en.tarajarmon.ch/img/home/687/4_2_d682cfce8f647dc7fd9799b00057e92e.1676389891.jpeg",
        
           
            
        },
    ];
